export const supportWhatsappLink =
  'https://wa.me/5531995130088?text=Ol%C3%A1%2C%20gostaria%20de%20suporte%20para%20o%20Cropwise%20Balance';
